<div class="modall">
    <div class="modal-contentt">
      <video oncontextmenu="return false;" #myVideo class="videoPlayerFullModal" #videoPlayer width="100%" height="100%" controls="false" autoplay controlsList="nodownload">
        <source [src]="selectedVideoUrl" type="video/mp4">
        <source [src]="selectedVideoUrl" type="video/ogg">
      </video>
      <!-- <button class="closeBtn" (click)="closeVideoModal()"> -->
        <span (click)="closeVideoModal()" class="cross">x</span>
      <!-- </button> -->
    </div>
  </div>